import posthog from 'posthog-js';

export function createPostHogAdapter(apiKey, options = {}) {
  posthog.init(apiKey, {
    api_host: options.apiHost || 'https://us.i.posthog.com',
    autocapture: false,
    capture_pageview: true,
    persistence: 'localStorage'
  });

  return {
    identify(userId, traits) {
      posthog.identify(String(userId), traits);
    },
    track(event, properties) {
      posthog.capture(event, properties);
    },
    reset() {
      posthog.reset();
    }
  };
}
